import React from 'react';

import { formatCurrency } from '@services/utils.service';

import './cost-table.styl';

function CostTable({ data, forPrint }) {
  const newData = data.filter(item => item.value !== 0)
  return (
    <div className={`cost-table ${forPrint ? 'cost-table--expand' : ''}`}>
      {/* <h3>
        Cost per class
      </h3> */}
      <table className="cost-table__table">
        <thead className="cost-table__header">
          <tr>
            <th className="cost-table__header">Class</th>
            <th className="cost-table__header">Estimated damage costs</th>
          </tr>
        </thead>
        <tbody>
          {newData.map((entry) => {
            return (
              <tr key={entry.name}>
                <td>{entry.name}</td>
                <td>{formatCurrency(entry.value)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default CostTable;